import { getPathNameArray, getRelativePathFromLink } from "@/utils/url";
import { SearchResultItemType } from "../../useSearch";

export const isGlossary = (url: string): boolean => {
  return getPathNameArray({ url })[0] === "glossar";
};

export const getTypeLabel = (type: string, locale = "de"): string => {
  switch (type) {
    case "Rezept":
      return locale === "de" ? "Rezept" : "Recette";
    case "Zutat":
      return locale === "de" ? "Zutat" : "Ingrédient";
    case "Kategorie":
      return locale === "de" ? "Kategorie" : "Catégorie";
    case "Zubereitungsart":
      return locale === "de" ? "Zubereitungsart" : "Mode de préparation";
    case "Saison":
      return "Saison";
    case "Beitrag":
      return locale === "de" ? "Beitrag" : "Article";
    default:
      return "";
  }
};

export const makePageLink = (resultItem: SearchResultItemType): string => {
  if (!isGlossary(resultItem.value_link) || resultItem.is_subpage) {
    return getRelativePathFromLink(resultItem.value_link);
  }
  if (isGlossary(resultItem.value_link) && !resultItem.is_subpage) {
    return `/glossar#${resultItem.value_slug}`;
  }
  return "/";
};
